'use strict';
const traverse = require('@mindmup/mapjs-core/src/content/traverse'),
	goldAssetCore = require('@mindmup/mindmup-common/src/gold-asset-core'),
	pushAsset = function (assetId, assetIds) {
		if (assetId && !assetIds.includes(assetId)) {
			assetIds.push(assetId);
		}
	},
	assetIdsFromContent = function (content, onlyIcons) {
		if (!content) {
			throw 'invalid-args';
		}
		const assetIds = [];
		traverse(content, function (idea) {
			pushAsset(goldAssetCore.assetIdFromIcon(idea), assetIds);
			if (!onlyIcons) {
				pushAsset(goldAssetCore.assetIdFromAttachment(idea), assetIds);
			}
		});
		return assetIds;
	},
	uploadImageAsset = function (fileId, idea, s3FileModel) {
		const image = goldAssetCore.getUploadableImage(idea);
		return image && s3FileModel.uploadAsset(fileId, image.url).then(function (imageId) {
			image.url = goldAssetCore.resourceIdFromAssetId(imageId);
			return imageId;
		});
	},
	uploadAttachmentAsset = function (fileId, idea, s3FileModel) {
		const attachment = goldAssetCore.getUploadableAttachment(idea);
		if (attachment) {
			return s3FileModel.uploadAsset(fileId, attachment.content)
			.then(function (assetId) {
				delete attachment.content;
				delete attachment.dataUriEncoded;
				attachment.goldAssetId = goldAssetCore.resourceIdFromAssetId(assetId);
				return assetId;
			});
		}
	},
	uploadAssets = function (fileId, idea, s3FileModel) {
		const promises = [];
		promises.push(uploadImageAsset(fileId, idea, s3FileModel));
		promises.push(uploadAttachmentAsset(fileId, idea, s3FileModel));
		return Promise.all(promises);
	};

module.exports = Object.assign({
	assetIdsFromContent,
	uploadAttachmentAsset,
	uploadImageAsset,
	uploadAssets
}, goldAssetCore);



